import { AdminResetPassReq } from '../../redux/slices/admin.slice'
import ButtonSpinner from '../../components/common/ButtonSpinner'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Form, Row, Col } from 'react-bootstrap'
import { Fragment, useEffect, useState } from 'react'
import Images from '../../assets/js/images'

const ResetPassword = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [params] = useSearchParams()
    const [token, setToken] = useState('')
    const { mloading } = useSelector(state => state.AdminSlice)


    const handleSubmit = (e) => {
        e.preventDefault()
        const form = new FormData(e.target)
        const formData = Object.fromEntries(form)
        dispatch(AdminResetPassReq({ data: formData, navigate }))
    }

    useEffect(() => {
        params.get('token') ? setToken(params.get('token')) : setToken('');
        // eslint-disable-next-line
    }, [])

    return (
        <Fragment>
            <div className="wrapper">
                <div className="authentication-reset-password d-flex align-items-center justify-content-center">
                    <div className="container">
                        <Row className='align-items-center'>
                            <Col md={6} className='text-center'>
                                <img src={Images?.NewLogo} alt="logo icon" style={{ width: '200px' }} className='mx-auto' />
                                <div style={{ backgroundImage: `url(${Images?.BgLogin})`, backgroundSize: 'cover' }} className='text-center'>
                                    <div style={{ minHeight: '450px' }} className='position-relative'>
                                        <img src={Images?.Car} className='position-absolute start-0' style={{ bottom: '70px', width: '500px' }} />
                                    </div>
                                </div>
                            </Col>
                            <Col md={6}>
                                <Row>
                                    <Col sm={10} md={8} className='mx-auto'>
                                        <Card className="login-box">
                                            <Card.Body className="card-body">
                                                <div className="p-5">
                                                    <h4 className="font-weight-bold mb-4 text-center">Set Password</h4>
                                                    <Form onSubmit={handleSubmit}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Control type="text" name="password" placeholder="Enter New Password" />
                                                            <Form.Control type="hidden" name="token" value={token} />
                                                        </Form.Group>
                                                        <div className="mb-3">
                                                            <Form.Control type="text" name="confirmpassword" placeholder="Confirm New Password" />
                                                        </div>
                                                        <div className="d-grid gap-2">
                                                            <button type="submit" className="btn btn-primary btn-sm m-0 text-uppercase">Set Password {mloading && <ButtonSpinner />}</button>
                                                        </div>
                                                    </Form>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default ResetPassword
